// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const straightTheme = {
  primary: "#ae8c39",
  secondary: "#03a9f4",
  accent: "#00bcd4",
  error: "#f44336",
  warning: "#009688",
  info: "#4caf50",
  success: "#ff5722",
};
const gayTheme = {
  gay_primary: "#88c3fa",
  gay_secondary: "#03a9f4",
  gay_accent: "#00bcd4",
  gay_error: "#f44336",
  gay_warning: "#009688",
  gay_info: "#4caf50",
  gay_success: "#ff5722",
};
const lesbianTheme = {
  lesbian_primary: "#9e2eec",
  lesbian_secondary: "#03a9f4",
  lesbian_accent: "#00bcd4",
  lesbian_error: "#f44336",
  lesbian_warning: "#009688",
  lesbian_info: "#4caf50",
  lesbian_success: "#ff5722",
};

const themes = { ...straightTheme, ...gayTheme, ...lesbianTheme };

const vuetify = new Vuetify({
  breakpoint: {
    mobileBreakpoint: 768, thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1280,
    },
  },


  theme: {
    defaultTheme: "straight",
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        ...themes,
      },
      dark: {
        ...themes,
      },
    },
  },



});

export default vuetify;
